import { render, staticRenderFns } from "./PDFPreview.vue?vue&type=template&id=a6a8a234&scoped=true"
import script from "./PDFPreview.vue?vue&type=script&lang=ts"
export * from "./PDFPreview.vue?vue&type=script&lang=ts"
import style0 from "./PDFPreview.vue?vue&type=style&index=0&id=a6a8a234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a8a234",
  null
  
)

export default component.exports